import { createStore } from 'satcheljs';
var undoStoreData = {
    hasUndoableAction: false,
};
var undoStore = createStore('undo', undoStoreData)();
export default undoStore;
//# sourceMappingURL=undoStore.js.map